import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

const useSelectHelpers = (
  value,
  options,
  required = false,
  isDirty = false
) => {
  const intl = useIntl()

  const [{ isSearching, searchMatches }, setHelpers] = useState({
    isSearching: false,
    searchMatches: 0
  })

  const handleSearch = (searchArgument) => {
    setHelpers((prev) => ({
      ...prev,
      isSearching: !!searchArgument,
      searchMatches: options.filter(({ label }) =>
        label.includes(searchArgument)
      ).length
    }))
    return searchArgument
  }

  const hint = useMemo(() => {
    return isSearching && searchMatches === 0
      ? intl.formatMessage({ id: 'Load.MailupCommon.InputStatusNoMatches' })
      : undefined
  }, [isSearching, searchMatches])

  return {
    onSearch: handleSearch,
    hint,
    error:
      required &&
      isDirty &&
      (Array.isArray(value) ? value.length === 0 : !value)
  }
}

export default useSelectHelpers
